<template>
  <div class="relative flex items-center">
    <InputText
      :id="id"
      v-model.trim="inputValue"
      v-model:value="inputValue"
      :class-object="mergedClassObject"
      :type="isPasswordVisible ? 'text' : 'password'"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :checked="checked"
      :disabled="disabled"
      :name="name"
      :placeholder="placeholder === '' ? $t('common.placeholder.password') : placeholder"
      :readonly="readonly"
      :required="required"
      :size="size"
      class="pr-8"
    />
    <div class="absolute right-2 cursor-pointer flex items-center h-full" @click="togglePasswordVisibility">
      <i :class="isPasswordVisible ? 'fas fa-eye' : 'far fa-eye-slash'"></i>
    </div>
  </div>
</template>

<script>
import InputText from '@/common/components/atoms/InputText'

export default {
  name: 'InputPassword',
  components: {
    InputText,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    classObject: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: String,
      default: 'password',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    checked: Boolean,
    disabled: Boolean,
    name: {
      type: String,
      default: 'password',
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: Boolean,
    required: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    autofocus: Boolean,
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputValue: this.value,
      mergedClassObject: {},
      defaultClassObject: {},
      isPasswordVisible: false,
    }
  },
  watch: {
    inputValue(val) {
      this.$emit('update:value', val)
    },
  },
  created() {
    this.mergedClassObject = Object.assign(this.defaultClassObject, this.classObject)
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible
    },
  },
}
</script>

<style scoped lang="scss">

</style>
